export const TIMING = 1000;

export const PADDING_TOP = '24px';
export const PADDING_BOTTOM = '16px';
export const PADDING_VERTICAL = '40px';

export const MAX_WIDTH = '1376px';

export const STYLE = {
    open: {
        width: '296px',
        padding: '32px',
        iconSize: 40,
    },
    close: {
        width: '64px',
        padding: '16px',
        iconSize: 30,
    },
};

export function getStyle(open: boolean) {
    return STYLE[open ? 'open' : 'close'];
}
